import '../../styles/EventsStyles/PresenterAvatar.css';
import { initials } from "../../webinars/format";

interface PresenterAvatarProps {
  name: string;
  /** From the presenter photo library; initials are shown without one */
  photoUrl?: string;
  size: "sm" | "lg";
}

// The presenter's name is always shown next to the avatar, so the image itself is decorative
export default function PresenterAvatar({ name, photoUrl, size }: PresenterAvatarProps) {
  if (photoUrl) {
    return <img className={`ev-avatar ev-avatar--${size}`} src={photoUrl} alt="" />;
  }
  return (
    <span className={`ev-avatar ev-avatar--${size} ev-avatar--initials`} aria-hidden="true">
      {initials(name) || "KM"}
    </span>
  );
}
